export default function Footer() {
    return (
		<footer id="main-footer">
			<div className="sfContentBlock">
				<div className="bottom-nav">
					<img className="mobile-only" src="/assets/kubotatractor/images/for-earth-for-life-mobile.png" alt="For Earth, For Life" loading="lazy" />
					<ul className="nav global-nav">
						<li>
							<a target="_blank" rel="noreferrer" href="https://www.kubota.com/">Kubota Group</a>
						</li>
						<li>
							<a target="_blank" rel="noreferrer" href="https://www.kubotacreditusa.com/homePrepare.do">
								<img src="/assets/kubotatractor/images/folder-icon.png" alt="Folder Icon" loading="lazy" />
							</a>
						</li>
						<li>
							<a target="_blank" rel="noreferrer" href="https://www.kubota.com/">
								<img src="/assets/kubotatractor/images/globe-icon.png" alt="Globe Icon" loading="lazy" />
							</a>
						</li>
					</ul>
					<ul className="nav">
						<li>
							<a href="https://www.kubotausa.com/terms-of-use">Terms of Use</a>
						</li>
						<li>
							<a href="https://www.kubotausa.com/privacy-policy">Privacy Policy</a>
						</li>
						<li>
							<a href="https://start.buildmykubota.com/sitemap.xml">Site Map</a>
						</li>
						<li>
							<a href="https://www.kubotausa.com/about/exercise-your-rights">Exercise Your Rights</a>
						</li>
						<li>
							<a href="https://www.kubotausa.com/about/cookie-notice">Cookie Notice</a>
						</li>
					</ul>
					<div className="copyright">
						<span>
							<strong>Kubota Tractor Corporation</strong>
						</span>
						<span>&copy; 1996 - {new Date().getFullYear()} Kubota Tractor Corporation</span>
					</div>
				</div>
			</div>
		</footer>
    );
}